import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  cancelAdminTrial,
  extendAdminTrial,
  resumeAdminTrial,
  suspendAdminTrial,
} from '../services/trials.api';
import type {
  CancelAdminTrialBody,
  ExtendAdminTrialBody,
  ResumeAdminTrialBody,
  SuspendAdminTrialBody,
} from '../types/adminTrial';

const TRIALS_QUERY_KEY = ['admin', 'trials'] as const;

export function useExtendAdminTrial() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      subscriptionId,
      data,
    }: {
      subscriptionId: string;
      data: ExtendAdminTrialBody;
    }) => extendAdminTrial(subscriptionId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRIALS_QUERY_KEY });
    },
  });
}

export function useCancelAdminTrial() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      subscriptionId,
      data,
    }: {
      subscriptionId: string;
      data: CancelAdminTrialBody;
    }) => cancelAdminTrial(subscriptionId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRIALS_QUERY_KEY });
    },
  });
}

export function useSuspendAdminTrial() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      subscriptionId,
      data,
    }: {
      subscriptionId: string;
      data: SuspendAdminTrialBody;
    }) => suspendAdminTrial(subscriptionId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRIALS_QUERY_KEY });
    },
  });
}

export function useResumeAdminTrial() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      subscriptionId,
      data,
    }: {
      subscriptionId: string;
      data: ResumeAdminTrialBody;
    }) => resumeAdminTrial(subscriptionId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRIALS_QUERY_KEY });
    },
  });
}
